import React from 'react'
import styles from "./Menu.module.css";

type MenuItemPropType = {
    id: string;
    title: string;
};

const ProjectionItem = ({ id, title }:MenuItemPropType) => {
  return (
    <div key={id} className={styles.projectionItem}>
      <span>{title}</span>
      <img src={require("../../assets/img.jpg")} alt="" />
    </div>
  )
}

export default ProjectionItem